<template>
  <div id="performanceContainer" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img src="../assets/images/navbar/ic_performance.webp" class="icon-pages" />
        <span class="page-title">{{ $t("page.performance") }}</span>
        <div class="page-des-line">
          <span class="page-des ml-10">{{
            $t("page.performance_description")
          }}</span>
        </div>
      </div>
      <el-tabs
        class="style-bar"
        v-bind:value="activeName"
        @tab-click="forceRerender"
      >
        <el-tab-pane label="Overview" name="overview" default>
          <span slot="label" class="title-bar">Overview</span>
          <overview
            v-if="renderComponent == false && activeName == 'overview'"
          ></overview>
        </el-tab-pane>
        <el-tab-pane label="Focus Areas" name="focus-areas">
          <span slot="label" class="title-bar">{{ $t("page.focus_areas") }}</span>
          <focus-areas
            v-if="renderComponent == false && activeName == 'focus-areas'"
          ></focus-areas>
        </el-tab-pane>
        <el-tab-pane label="Goals" name="goals">
          <span slot="label" class="title-bar">{{ $t("page.goals") }}</span>
          <goals
            v-if="renderComponent == false && activeName == 'goals'"
          ></goals>
        </el-tab-pane>
        <el-tab-pane label="Talent Matrix" name="talent-matrix">
          <span slot="label" class="title-bar">Talent Matrix</span>
          <talent-matrix
            v-if="renderComponent == false && activeName == 'talent-matrix'"
          ></talent-matrix>
        </el-tab-pane>
      </el-tabs>
      <component
        v-if="
          (activeName == 'overview' ||
            activeName == 'focus-areas' ||
            activeName == 'goals' ||
            activeName == 'talent-matrix') &&
          renderComponent
        "
        v-bind:is="activeName"
      ></component>
    </div>
  </div>
</template>

<script>
export default {
  name: "performance",
  components: {
    overview: require("./powerups/performance").default,
    "focus-areas": require("./performance/focus-areas").default,
    "goals": require("./performance/goals").default,
    "talent-matrix": require("./performance/talent-matrix").default,
  },
  data() {
    return {
      anchor: {
        overview: "overview",
        "focus-areas": "focus-areas",
        "goals": "goals",
        "talent-matrix": "talent-matrix",
      },
    };
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    activeName() {
      return this.$store.getters["performance/activeName"];
    },
    renderComponent() {
      return this.$store.getters["performance/renderComponent"];
    },
  },
  mounted() {
    let params = this.$router.currentRoute.params.tab;
    
    if (params && this.anchor[params]) {
      this.$store.commit("performance/setActiveTabs", {
        activeName: params,
        renderComponent: false,
      });
    } else {
      this.$router.push({ name: "performance", params: { tab: "overview" } });
    }
    this.rootChangeTabHandler = (item) => {
      if (item.path == "performance") {
        item.name = item.tab;
        this.forceRerender(item);
      }
    };
    this.$root.$on('changeTab', this.rootChangeTabHandler);
  },
  beforeDestroy() {
    if (this.rootChangeTabHandler) {
      this.$root.$off('changeTab', this.rootChangeTabHandler);
    }
  },
  methods: {
    forceRerender(obj) {
      if (this.renderComponent == true) {
        this.$store.commit("performance/setActiveTabs", {
          activeName: obj.name,
          renderComponent: false,
        });
      } else {
        this.$store.commit("performance/setActiveTabs", {
          activeName: obj.name,
          renderComponent: true,
        });
      }
      this.$router.push({ name: "performance", params: { tab: obj.name } });
    },
  },
};
</script>

<style>
#performanceContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 140px;
  text-align: center;
}
#performanceContainer .el-tabs__header {
  margin: 0px;
}
</style>
